import React from "react";

function ArrowIcon() {
  return (
    <svg aria-hidden="true" width="16" height="16" className="mx-2">
      <g
        fillRule="nonzero"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14.666 8h-14M8.167 15l7-7.023-7-6.977"></path>
      </g>
    </svg>
  );
}

export default ArrowIcon;
